<template>
  <section v-show="restrictions.length">
    <translate tag="h4"> Other restrictions </translate>
    <p
      v-for="(restriction, index) in restrictions"
      :key="index"
      class="restriction"
    >
      <template v-if="restriction.amenityIcon">
        <img
          v-if="facilityIcons[restriction.amenityIcon]"
          loading="lazy"
          :class="`icon ${restriction.amenityIcon}`"
          :src="facilityIcons[restriction.amenityIcon]"
          width="22"
          height="22"
        />
      </template>
      {{ restriction.name }}
    </p>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  async setup(props) {
    const iconModules = import.meta.glob<{ default: string }>(
      '@/assets/facility-icons/*.svg',
      {
        query: '?url',
        eager: false,
      },
    )
    const facilityIcons = {}
    if (props.restrictions?.length) {
      await Promise.all(
        props.restrictions.map(async (restriction) => {
          try {
            const iconPath = `/assets/facility-icons/${restriction.amenityIcon}.svg`
            const module = iconModules[iconPath]
            if (module) {
              const imported = await module()
              // Use direct assignment with ref
              facilityIcons[restriction.amenityIcon] = imported.default
            }
          } catch (err) {
            console.error(err)
          }
        }),
      )
    }
    return {
      facilityIcons,
      iconModules,
    }
  },
})
class OtherRestrictions extends Vue {
  @Prop()
  restrictions: Array<{
    amenityIcon: string
    name: string
  }>

  facilityIcons: Record<string, string>
  iconModules: Record<string, string>
}

export default toNative(OtherRestrictions)
</script>

<style scoped>
section {
  margin: 1.3em 0;
}

.restriction {
  margin: 0.2em 0;
}

.restriction .icon {
  width: 1.3em;
}
</style>
